import bannerCAWWorkshop from './bannerCAWWorkshop'
import bannerCommunitySurvey from './bannerCommunitySurvey'
import bannerJoinSession from './bannerJoinSession'
import bannerPendingApproval from './bannerPendingApproval'
import bannerReferredSeries from './bannerReferredSeries'
import bannerSATBootcamp from './bannerSATBootcamp'
import bannerSATBootcampMarketing from './bannerSATBootcampMarketing'
import bannerVolunteerHub from './bannerVolunteerHub'
import type { BannerDataLoader } from './types'

// The order of the items in this array is important
// Position in the array is treated as position in UI

export const banners: BannerDataLoader[] = [
  bannerPendingApproval,
  bannerJoinSession,
  bannerCommunitySurvey,
  bannerReferredSeries,
  // TODO: Replace these banners with bigger ads on the new dashboard or with toasts
  bannerCAWWorkshop,
  bannerSATBootcamp,
  bannerSATBootcampMarketing,
  bannerVolunteerHub,
]
